import store from "../../../store";
import { IConfiguration } from "../../../domain/configuration";
import { IContentSource } from "../../../domain/drawing";
import { IPrinterService } from "../../../domain/localhost";
import { Dictionary } from "../../../domain/system";
import { UrlSchemeClient } from "../../../utilities";
import { LoggerFactory } from "../../../utilities/logger";

export class PrinterService implements IPrinterService {
  async print(source: IContentSource, copies: number, shouldSelectPrinter: boolean, shouldPrintWatermarkForcibly: boolean, launchRequestKey: string): Promise<void> {
    await this.requestPrint(
      shouldSelectPrinter ? "printSourceToSelectedPrinter" : "printSource",
      source,
      copies,
      new Dictionary<string, string>(),
      shouldPrintWatermarkForcibly,
      launchRequestKey,
    );
  }

  private async requestPrint(action: string, source: IContentSource, copies: number, parameters: Dictionary<string, string>, shouldPrintWatermarkForcibly: boolean, launchRequestKey: string): Promise<void> {
    const requestCopies = copies
      ? copies
      : 1;  // 未指定時は1.
    if (requestCopies === 0) {
      PrinterService._logger.info("指定された部数が0なので印刷実行しません.");
      return;
    }
    parameters.set("action", action);
    parameters.set("source", window.btoa(source.source));
    parameters.set("copies", requestCopies.toString());
    if (shouldPrintWatermarkForcibly) {
      parameters.set("shouldPrintWatermarkForcibly", shouldPrintWatermarkForcibly.toString());
    }
    if (launchRequestKey) {
      parameters.set("launchRequestKey", launchRequestKey);
      if (!parameters.containsKey("token")) {
        parameters.set("token", store.getters.token);
      }
    }
    const query = parameters.keys.map(key => key + "=" + parameters.get(key)).join("&");
    const config = store.getters.configuration as IConfiguration;
    const url = config.behavior.localhost.schemeUrlPrefix + "?" + query;
    const client = new UrlSchemeClient();
    client.request(url);
  }

  async printTo(source: IContentSource, printerName: string, copies: number, launchRequestKey: string): Promise<void> {
    if (!printerName || (printerName === "")) {
      throw new Error("プリンタ名が指定されていません.");
    }
    const parameters = new Dictionary<string, string>();
    parameters.set("printerName", encodeURIComponent(printerName)); // プリンタ名に「:」とか「/」とか入る可能性はあると思うので部分的にURIエンコードする.
    await this.requestPrint("printSourceToSpecifiedPrinter", source, copies, parameters, false, launchRequestKey);
  }

  private static readonly _logger = LoggerFactory.getLogger();
}
